var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9049 3.33317C11.9049 4.25365 11.1587 4.99984 10.2382 4.99984C9.31776 4.99984 8.57157 4.25365 8.57157 3.33317C8.57157 2.4127 9.31776 1.6665 10.2382 1.6665C11.1587 1.6665 11.9049 2.4127 11.9049 3.33317ZM11.6663 9.99983C11.6663 10.9203 10.9202 11.6665 9.99968 11.6665C9.0792 11.6665 8.33301 10.9203 8.33301 9.99983C8.33301 9.07936 9.0792 8.33317 9.99968 8.33317C10.9202 8.33317 11.6663 9.07936 11.6663 9.99983ZM9.99968 18.3332C10.9202 18.3332 11.6663 17.587 11.6663 16.6665C11.6663 15.746 10.9202 14.9998 9.99968 14.9998C9.0792 14.9998 8.33301 15.746 8.33301 16.6665C8.33301 17.587 9.0792 18.3332 9.99968 18.3332Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnOptions);
export default __webpack_public_path__ + "static/media/icn_options.8f1ca34538733693dcb12815ae2683d6.svg";
export { ForwardRef as ReactComponent };